import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.scss";
import Logo from "../../../assets/wlc-logo-text.png";
import LogoSimple from "../../../assets/wlc-logo-simple.png";
import { IoChevronDown, IoClose } from "react-icons/io5";
import { menuItems } from "./data/data";
import { LuArrowLeftToLine, LuArrowRightToLine } from "react-icons/lu";
import { useTranslation } from "react-i18next";
import { useZone } from "../../../context/ZoneContext";
import {
    puedeVerAdministracion,
    puedeVerInformeVisitas,
    puedeVerObrasMenores,
} from "../../../utils/permisos";
import { RxDashboard } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";
import { LuUsers } from "react-icons/lu";
import { FaRegChartBar } from "react-icons/fa";
import { LuRecycle } from "react-icons/lu";
import { PiFactory } from "react-icons/pi";
import { IoConstructOutline } from "react-icons/io5";

const Sidebar = ({
    isOpen,
    isCollapsed,
    onToggleCollapse,
    onClose,
    userRole,
    userZona,
}) => {
    const [openMenus, setOpenMenus] = useState({});
    const [hoveredItem, setHoveredItem] = useState(null);
    const location = useLocation();
    const { t } = useTranslation();
    const { selectedZone } = useZone();

    const isMexico = selectedZone?.value === "2";

    /* Informes, como en la plataforma antigua: los administradores siempre, y el
       Intermediario solo si es de México. El de Europa no los ve, y el back se lo
       deniega igualmente (InformeController.AccesoInformesDenegado). */
    const puedeVerInformes =
        Number(userRole) !== 4 || String(userZona) === "2";

    const subItemsAdministrator = [
        {
            id: "paises",
            label: t("sidebar.paises"),
            path: "/administracion/paises",
        },
        {
            id: "comunidades",
            label: isMexico ? "Estados" : t("sidebar.comunidades"),
            path: "/administracion/comunidades",
        },
        {
            id: "provincias",
            label: isMexico ? "Municipios" : t("sidebar.provincias"),
            path: "/administracion/provincias",
        },
        {
            id: "productores",
            label: t("sidebar.productores"),
            path: "/administracion/productores",
        },
        {
            id: "intermediarios",
            label: t("sidebar.intermediarios"),
            path: "/administracion/intermediarios",
        },
        ...(userRole == 1
            ? [
                  {
                      id: "usuarios",
                      label: t("sidebar.usuarios"),
                      path: "/administracion/usuarios",
                  },
              ]
            : []),
    ];

    const menuItems = [
        {
            id: "dashboard",
            label: t("sidebar.dashboard"),
            icon: <RxDashboard />,
            path: "/dashboard",
            roles: ["Administrator", "User", "Supervisor", "Manager"],
        },
        {
            id: "administracion",
            label: t("sidebar.administracion"),
            icon: <IoSettingsOutline />,
            roles: ["Administrator"],
            subItems: subItemsAdministrator,
        },
        {
            id: "gestores",
            label: t("sidebar.gestores"),
            icon: <LuUsers />,
            path: "/gestores",
            roles: ["Administrator", "User", "Supervisor", "Manager"],
        },
        {
            id: "informes",
            label: t("sidebar.informes"),
            icon: <FaRegChartBar />,
            roles: ["Administrator", "User", "Supervisor", "Manager"],
            subItems: [
                {
                    id: "cantidades-generadas",
                    label: t("sidebar.generadas"),
                    path: "/informes/cantidades-generadas",
                },
                {
                    id: "costes",
                    label: t("sidebar.costes"),
                    path: "/informes/costes",
                },
                {
                    id: "segregacion-valorizacion",
                    label: t("sidebar.segregacionValorizacion"),
                    path: "/informes/segregacion-valorizacion",
                },
                {
                    id: "segregacion-total",
                    label: t("sidebar.segregacionTotal"),
                    path: "/informes/segregacion-total",
                },
                {
                    id: "datos-valorizacion",
                    label: t("sidebar.datosValorizacion"),
                    path: "/informes/datos-valorizacion",
                },
                {
                    id: "toneladas-valorizadas",
                    label: t("sidebar.toneladasValorizadas"),
                    path: "/informes/toneladas-valorizadas",
                },
                {
                    id: "costes-gestion",
                    label: t("sidebar.costesGestion"),
                    path: "/informes/costes-gestion",
                },
                {
                    id: "abono-chatarra",
                    label: t("sidebar.abonoChatarra"),
                    path: "/informes/abono-chatarra",
                },
                {
                    id: "ahorro-segregacion",
                    label: t("sidebar.ahorroSegregacion"),
                    path: "/informes/ahorro-segregacion",
                },
                /*{
                    id: "huella-carbono",
                    label: t("sidebar.huellaCarbono"),
                    path: "/informes/huella-carbono",
                },*/
                {
                    id: "informes-personalizados",
                    label: t("sidebar.informesPersonalizados"),
                    path: "/informes/informes-personalizados",
                },
                ...(puedeVerInformeVisitas(userRole)
                    ? [
                          {
                              id: "informes-visitas",
                              label: t("sidebar.informesVisitas"),
                              path: "/informes/informes-visitas",
                          },
                      ]
                    : []),
            ],
        },
        {
            id: "residuos",
            label: t("sidebar.residuos"),
            icon: <LuRecycle />,
            path: "/residuos",
            roles: ["Administrator", "User", "Supervisor", "Manager"],
        },
        {
            id: "centros-productores",
            label: t("sidebar.centrosProductores"),
            icon: <PiFactory />,
            path: "/centros-productores",
            roles: ["Administrator", "User", "Supervisor", "Manager"],
        },
        {
            id: "obras-menores",
            label: t("sidebar.obrasMenores"),
            icon: <PiFactory />,
            path: "/obras-menores",
            roles: ["Administrator", "User", "Supervisor", "Manager"],
        },
    ]
        .filter((item) => item.id !== "informes" || puedeVerInformes)
        .filter(
            (item) =>
                item.id !== "obras-menores" ||
                puedeVerObrasMenores({ role: userRole, codZona: userZona })
        )
        /* Administración, como en el legacy (_Layout.cshtml): el Intermediario no
           la ve. El campo roles de cada entrada no se aplicaba en ningún sitio. */
        .filter(
            (item) =>
                item.id !== "administracion" ||
                puedeVerAdministracion(userRole)
        );

    const toggleMenu = (menuKey) => {
        if (
            isCollapsed &&
            menuItems.find((item) => item.id === menuKey)?.subItems
        ) {
            onToggleCollapse();
        }

        setOpenMenus((prev) => ({
            ...prev,
            [menuKey]: !prev[menuKey],
        }));
    };

    const toggleCollapse = () => {
        onToggleCollapse();
        if (!isCollapsed) {
            setOpenMenus({});
        }
    };

    const hasActiveSubmenu = (submenu) => {
        return submenu.some((subItem) => isActiveRoute(subItem.path));
    };

    const handleItemHover = (itemKey, isHovering) => {
        if (isCollapsed) {
            setHoveredItem(isHovering ? itemKey : null);
        }
    };
    const isActiveRoute = (path) => {
        return (
            location.pathname === path ||
            location.pathname.startsWith(path + "/")
        );
    };

    const handleLinkClick = () => {
        if (window.innerWidth <= 1024) {
            onClose();
        }
    };

    const handleOverlayClick = () => {
        if (window.innerWidth <= 1024) {
            onClose();
        }
    };

    return (
        <>
            {isOpen && (
                <div className="sidebar-overlay" onClick={handleOverlayClick} />
            )}

            <aside
                className={`sidebar ${
                    isCollapsed ? "sidebar--collapsed" : ""
                } ${isOpen ? "sidebar--open" : ""}`}
            >
                <div className="sidebar__header">
                    <Link to="/" className="sidebar__logo">
                        <img
                            src={isCollapsed ? LogoSimple : Logo}
                            alt="WLC Logo"
                            className="sidebar__logo-img"
                        />
                    </Link>

                    <button
                        className="sidebar__close-btn"
                        onClick={onClose}
                        aria-label="Cerrar menú"
                    >
                        <IoClose />
                    </button>
                </div>

                <nav className="sidebar__nav">
                    <ul className="sidebar__menu">
                        {menuItems.map((item) => (
                            <li
                                key={item.id}
                                className="sidebar__menu-item"
                                onMouseEnter={() =>
                                    handleItemHover(item.id, true)
                                }
                                onMouseLeave={() =>
                                    handleItemHover(item.id, false)
                                }
                            >
                                {isCollapsed && hoveredItem === item.id && (
                                    <div className="sidebar__tooltip">
                                        {item.label}
                                    </div>
                                )}

                                {Array.isArray(item.subItems) &&
                                item.subItems.length > 0 ? (
                                    <>
                                        <button
                                            className={`sidebar__menu-link sidebar__menu-link--expandable ${
                                                openMenus[item.id]
                                                    ? "sidebar__menu-link--expanded"
                                                    : ""
                                            } ${
                                                hasActiveSubmenu(item.subItems)
                                                    ? "sidebar__menu-link--active"
                                                    : ""
                                            }`}
                                            onClick={() => toggleMenu(item.id)}
                                            title={
                                                isCollapsed
                                                    ? item.label
                                                    : undefined
                                            }
                                        >
                                            <span className="sidebar__menu-icon">
                                                {item.icon}
                                            </span>
                                            {!isCollapsed && (
                                                <>
                                                    <span className="sidebar__menu-text">
                                                        {item.label}
                                                    </span>
                                                    <IoChevronDown className="sidebar__menu-arrow" />
                                                </>
                                            )}
                                        </button>
                                        {!isCollapsed && openMenus[item.id] && (
                                            <ul className="sidebar__submenu">
                                                {item.subItems.map(
                                                    (subItem) => (
                                                        <li
                                                            key={subItem.path}
                                                            className="sidebar__submenu-item"
                                                        >
                                                            <Link
                                                                to={
                                                                    subItem.path
                                                                }
                                                                className={`sidebar__submenu-link ${
                                                                    isActiveRoute(
                                                                        subItem.path
                                                                    )
                                                                        ? "sidebar__submenu-link--active"
                                                                        : ""
                                                                }`}
                                                                onClick={
                                                                    handleLinkClick
                                                                }
                                                            >
                                                                {subItem.label}
                                                            </Link>
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        )}
                                    </>
                                ) : (
                                    <Link
                                        to={item.path}
                                        className={`sidebar__menu-link ${
                                            isActiveRoute(item.path)
                                                ? "sidebar__menu-link--active"
                                                : ""
                                        }`}
                                        title={
                                            isCollapsed ? item.label : undefined
                                        }
                                        onClick={handleLinkClick}
                                    >
                                        <span className="sidebar__menu-icon">
                                            {item.icon}
                                        </span>
                                        {!isCollapsed && (
                                            <span className="sidebar__menu-text">
                                                {item.label}
                                            </span>
                                        )}
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="sidebar__footer">
                    <button
                        className="sidebar__collapse-btn"
                        onClick={toggleCollapse}
                        title={isCollapsed ? "Expandir menú" : "Contraer menú"}
                    >
                        {isCollapsed ? (
                            <LuArrowRightToLine />
                        ) : (
                            <LuArrowLeftToLine />
                        )}
                    </button>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
